/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div is="slide-indicators" class="image-gallery__slide-indicators';
    if (context.hidden) {
      __p += ' hidden';
    }
    __p += '"><div class="slide-indicators ';
    if (context.alternativeActiveHighlight) {
      __p += 'slide-indicators--alternative';
    }
    __p += '"><span class="fullscreen-overlay-indicators-inner">';
    _.times(context.maxSlides, function(idx) {
      __p += '<span class="slide-indicators__indicator';
      if (idx === context.selectedIndex) {
        __p += ' slide-indicators__indicator--active';
      }
      __p += '" data-index="' +
        ((__t = (idx)) == null ? '' : _.escape(__t)) +
        '"></span>';
    })
    __p += '</span></div></div>';
    return __p;
  }
});